import React, { useState } from 'react'

export default function Thumb({ src, RenderError, ...props }) {
  const [error, setError] = useState(false)

  const handleError = () => {
    setError(true)
  }

  if (error) {
    return <RenderError />
  }

  return <img src={src} onError={handleError} {...props} />
}
